module.exports = __webpack_public_path__ + "img/webinar2.3f4c2fe9.png";